/* Marek Supplements x Zipify OCU pre-checkout popup helpers (fail-safe)
   v1.2, 2026-10-01. Load in layout/theme.liquid before </body> (all markets):
     <script src="{{ 'ocu-popup.js' | asset_url }}" defer></script>

   1. ONE DECISION PER POPUP (all markets)
      Upgrades: the buttons decide ("Upgrade to Subscription" vs decline), so the
      Subscribe option is selected for the shopper. Add-ons: One-time is selected,
      so the popup asks one question ("Add X to order?"). Only once Zipify reports
      the radio as checked does the dialog get data-mk-choice, which is what lets
      ocu-popup-skin.css hide the radio rows. If anything fails, the radios stay
      visible and work exactly as Zipify built them.

   2. FREE-SHIPPING LINE (US shoppers, add-ons only)
      When the cart is under $99 and the add-on lifts it to $99+, insert ONE line:
        "Glycine brings your order to $105.00. US orders $99+ after discounts ship free."
      No line in every other case (cart already $99+, add-on doesn't reach $99,
      CA/AU, upgrades, JS error, Zipify markup change).
*/
(function () {
  'use strict';
  var FREE_AT = 9900;    // cents. US free shipping threshold (evaluated after discounts)
  var MIN_AFTER = 9900;  // cents. Raise to 11000 for the line to survive a 10% code
  var isUS = !!(window.Shopify && window.Shopify.country === 'US');

  function isAddOn(dialog) { return !!dialog.querySelector('[data-testid="incart-content"]'); }

  /* ---------- 1. one decision per popup ---------- */
  function choose(dialog) {
    try {
      if (dialog.getAttribute('data-mk-choice')) return true;
      var rows = dialog.querySelectorAll('.ocu-selection-container');
      if (!rows.length) return false;                       // subscription-only offer: nothing to choose
      var wantSub = !isAddOn(dialog), target = null;
      for (var i = 0; i < rows.length; i++) {
        var isSub = !!rows[i].querySelector('.ocu-save-block') || /subscri/i.test(rows[i].textContent || '');
        if (isSub === wantSub) { target = rows[i]; break; }
      }
      var input = target && target.querySelector('input.ocu-subscriptions__radio');
      if (!input) return false;
      if (!input.checked) input.click();                    // let Zipify (Vue) handle it like a real tap
      if (input.checked) {
        dialog.setAttribute('data-mk-choice', wantSub ? 'subscription' : 'onetime');
        return true;
      }
    } catch (e) {}
    return false;
  }

  /* ---------- 2. free-shipping line ---------- */
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); } catch (e) {}

  function cents(el) {
    var n = parseFloat(String((el && el.textContent) || '').replace(/[^0-9.]/g, ''));
    return isFinite(n) ? Math.round(n * 100) : NaN;
  }

  function shipLine(dialog, cart) {
    try {
      var box = dialog.querySelector('[data-testid="incart-content"] .ocu-hero-content__container');
      if (!box || !fmt) return;
      var old = box.querySelector('.mk-ocu-ship');
      if (old) old.parentNode.removeChild(old);
      if (!cart || cart.currency !== 'USD') return;
      var anchor = box.querySelector(':scope > .ocu-mobile__container');
      var nameEl = box.querySelector('.ocu-hero-title p');
      var add = cents(dialog.querySelector('[data-ocu-price-now-product-id]'));
      var total = Number(cart.total_price);                 // cents, after cart discounts, before shipping
      if (!anchor || !nameEl || !isFinite(add) || !isFinite(total)) return;
      if (!(total < FREE_AT) || !(total + add >= MIN_AFTER)) return;
      var p = document.createElement('p'), b = document.createElement('strong');
      p.className = 'mk-ocu-ship';
      b.textContent = fmt.format((total + add) / 100);
      p.appendChild(document.createTextNode(nameEl.textContent.trim() + ' brings your order to '));
      p.appendChild(b);
      p.appendChild(document.createTextNode('. US orders $99+ after discounts ship free.'));
      box.insertBefore(p, anchor);                          // before the description, never last
    } catch (e) { /* fail silent: popup renders exactly as without this file */ }
  }

  /* ---------- wiring ---------- */
  function onOpen(dialog) {
    if (dialog.getAttribute('data-mk-ocu')) return;
    dialog.setAttribute('data-mk-ocu', '1');
    // Zipify mounts content just after the dialog opens: retry briefly.
    [0, 120, 350, 800, 1600].forEach(function (ms) { setTimeout(function () { choose(dialog); }, ms); });
    if (!isUS) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        setTimeout(function () { shipLine(dialog, cart); }, 150);
        dialog.addEventListener('change', function () { setTimeout(function () { shipLine(dialog, cart); }, 0); });
      })
      .catch(function () {});
  }

  try {
    new MutationObserver(function () {
      var d = document.querySelector('dialog.ocu-pre[open]');
      if (d) onOpen(d);
    }).observe(document.body || document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  } catch (e) {}
})();
